import React from 'react';

export default class RangeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: 'option1'};
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
    this.props.updateSelectChoice(event.target.value);
  }

  render() {
    return (
      <div>
        <p>Choose minimum and maximum numbers:</p>
        <div className="inequality-range-select">
          <form>
            <select value={this.state.value} onChange={this.handleChange}>
              <option value="option1">1 - 100</option>
              <option value="option2">100 - 1,000</option>
              <option value="option3">1,000 - 10,000</option>
            </select>
          </form>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/inequality/select_range.js
 **/